/**
 * Auswahl einer Auszahlungsperiode: suchen und vorauswählen.
 *
 * Mit dem Altbestand stehen dort alle Halbmonate seit Januar. Als Tabelle war
 * das eine lange Liste über der eigentlichen Arbeit; jetzt ist es ein Feld mit
 * Suche, und vorne steht die Periode, an der etwas zu tun ist.
 */

export interface PeriodOption {
  id: string;
  label: string;
  dateFrom: string;
  dateTo: string;
  status: string;
}

/** `2026-09-01` → `01.09.2026` */
function deutsch(iso: string): string {
  const [y, m, d] = iso.split("-");
  return `${d}.${m}.${y}`;
}

/**
 * Passt die Periode zur Eingabe? Jedes Wort muss irgendwo vorkommen — im
 * Namen, im Zeitraum oder im Status. „sept 26“, „09.2026“, „ausgezahlt“ und
 * „zweite juli“ finden, was man erwartet.
 */
export function matchesPeriodQuery(p: PeriodOption, query: string, statusText: string): boolean {
  const words = query.toLowerCase().split(/\s+/).filter(Boolean);
  if (words.length === 0) return true;
  const haystack = [p.label, deutsch(p.dateFrom), deutsch(p.dateTo), p.dateFrom, p.dateTo, statusText]
    .join(" ")
    .toLowerCase();
  return words.every((w) => haystack.includes(w));
}

/**
 * Welche Periode zuerst gezeigt wird: die neueste, an der noch etwas zu tun
 * ist (offen, gesperrt, exportiert). Ist alles ausgezahlt, die neueste.
 * Erwartet die Liste neueste zuerst, wie die API sie liefert.
 */
export function defaultPeriodId(periods: readonly PeriodOption[]): string | null {
  return (periods.find((p) => p.status !== "PAID") ?? periods[0])?.id ?? null;
}
